import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=0e1a75c6&scoped=true"
import script from "./FormTable.vue?vue&type=script&lang=js"
export * from "./FormTable.vue?vue&type=script&lang=js"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=0e1a75c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a75c6",
  null
  
)

export default component.exports